export const jsonEgStr = `{
  "list": [
    {
      "type": "input",
      "name": "单行文本",
      "suffix": "",
      "showName": true,
      "icon": "icon-input",
      "options": {
        "width": "100%",
        "length": 50,
        "defaultValue": "",
        "required": false,
        "hidden": false,
        "disabled": false,
        "dataType": "string",
        "pattern": "",
        "placeholder": "",
        "customClass": "",
        "customDesc": ""
      },
      "eventOptions": {
        "builtIn": []
      },
      "key": "1563939713608",
      "model": "input_1563939713608",
      "rules": [
        {
          "type": "string",
          "message": "单行文本格式不正确"
        }
      ]
    },
    {
      "type": "textarea",
      "name": "多行文本",
      "showName": true,
      "icon": "icon-diy-com-textarea",
      "options": {
        "width": "100%",
        "length": 100,
        "defaultValue": "",
        "required": false,
        "hidden": false,
        "disabled": false,
        "pattern": "",
        "placeholder": "",
        "customClass": "",
        "customDesc": ""
      },
      "eventOptions": {
        "builtIn": []
      },
      "key": "1563939715983",
      "model": "textarea_1563939715983",
      "rules": []
    }
  ],
  "config": {
    "labelWidth": 100,
    "labelPosition": "left",
    "size": "small",
    "disabled": false,
    "justShow": false,
    "customClass": ""
  }
}`
